import exclusiveInterfaces from './interface'

const interfaces = window.API.wrap(exclusiveInterfaces, 'xhrMitraWallet')

export default interfaces
